import React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { IOrganization } from '../../../modules/unsw-fhir/Organization';

const OrganizationsTable = ({
  organizations,
  loading,
}: {
  organizations: IOrganization[];
  loading?: boolean;
}) => (
  <ReactTable
    filterable
    showPageSizeOptions={false}
    minRows={10}
    pageSize={10}
    loading={loading}
    data={organizations}
    className={'-highlight'}
    columns={[
      { Header: 'Name', accessor: 'name', sortable: false },
      {
        Cell: props => {
          const { value } = props;
          return (
            <div>
              <Button block tag={Link} to={`/organization/${value}/`}>
                View
              </Button>
            </div>
          );
        },
        accessor: d => d.id,
        id: 'buttons',
        resizable: false,
        sortable: false,
        filterable: false,
        maxWidth: 200,
      },
    ]}></ReactTable>
);
export default OrganizationsTable;
